/* Size tiles: if the matching facet input exists on the page, toggle it (AJAX filter);
   otherwise fall through to the tile's normal href navigation. */
(function () {
  "use strict";
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest(".ga-size-tile[data-ga-filter-value]");
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var param = a.dataset.gaFilterParam;
    var value = a.dataset.gaFilterValue;
    var forms = document.querySelectorAll("facet-filters-form form");
    for (var f = 0; f < forms.length; f++) {
      var inputs = forms[f].querySelectorAll('input[type="checkbox"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].name === param && inputs[i].value === value) {
          e.preventDefault();
          inputs[i].checked = !inputs[i].checked;
          inputs[i].dispatchEvent(new Event("input", { bubbles: true }));
          inputs[i].dispatchEvent(new Event("change", { bubbles: true }));
          return;
        }
      }
    }
  });
})();
